import Swiper from "swiper";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";
import "./services.css";

const setupSlider = (el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    simulateTouch: false,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1500: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
    },
    on: {
      init: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
      resize: (swiper) => {
        if (swiper.isLocked) {
          el.classList.add("is-locked");
        } else {
          el.classList.remove("is-locked");
        }
      },
    },
  });

  return swiper;
};

document.querySelectorAll(".element-services").forEach((el) => {
  el.querySelectorAll(".services-slider").forEach((panel) => {
    let swiper = setupSlider(panel);

    panel.addEventListener("services:toggle", (e) => {
      const isViewAll = e.detail.all;

      if (isViewAll) {
        panel.classList.add("is-view-all");
        swiper.destroy(true, true);
      } else {
        panel.classList.remove("is-view-all");
        swiper = setupSlider(panel);
      }

      ScrollTrigger.refresh();
    });
  });
});
